import React, { useMemo, useState, } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import Select from 'react-select';
import { entries, omit, } from 'lodash';
import { toast } from 'react-toastify';

import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ProductSelectOptionLabel from '../ProductSelectOptionLabel';
import { saveProductMallMapping, } from '../../shared/models/productMallMapping';

export default function MallProductMappingModal (props) {
  const { isOpen, onClose, tenant, shop, mallProduct, } = props;
  const productChunks = useCollectionSubscription(isOpen && tenant.ref.collection('productChunks'), [tenant.id, isOpen]);
  const products = useMemo(() => {
    return productChunks.flatMap(_ => entries(omit(_, ['id', 'ref'])).map(([k, v]) => ({ id: k, ref: tenant.ref.collection('products').doc(k), ...v, }))).filter(_ => !_.hides);
  }, [productChunks]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sameSkuProduct = products.find(_ => _.sku === mallProduct.sku);
  const productId = selectedProductId ?? sameSkuProduct?.id;
  const options = products.map(_ => ({ label: [_.sku, _.name].join(' '), value: _.id, product: _ }));

  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      await saveProductMallMapping(tenant, shop, {
        productId,
        values: { shopifySku: mallProduct.sku },
        cacheValues: { shopifyVariantId: mallProduct.mallVariantId, shopifyInventoryItemId: mallProduct.mallInventoryItemId },
      });
      await tenant.ref.update({ shouldUpdateMallStocks: true });
      toast.success('紐付けました');
      onClose();
    } catch (e) {
      console.error(e);
      toast.error(e.message || '紐付けに失敗しました');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>LOGISP商品と紐付け</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <div className="text-muted small">Shopify商品</div>
          <div>{mallProduct.productTitle}{mallProduct.variantTitle !== 'Default Title' && ` / ${mallProduct.variantTitle}`}</div>
          <div className="small">SKU: {mallProduct.sku}</div>
        </div>
        <div className="text-muted small">LOGISP商品</div>
        <Select
          value={options.find(_ => _.value === productId) ?? null}
          options={options}
          onChange={_ => setSelectedProductId(_?.value ?? null)}
          formatOptionLabel={_ => <ProductSelectOptionLabel product={_.product} />}
          placeholder="SKU・商品名で検索"
          noOptionsMessage={() => '該当する商品がありません'}
        />
        {sameSkuProduct != null && productId === sameSkuProduct.id && <div className="small text-muted mt-1">SKUが一致するLOGISP商品を選択しています</div>}
        {shop.isStockSyncEnabled !== false && <div className="small text-muted mt-2">紐付けると、LOGISPの在庫数がShopifyに連携されます。</div>}
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>キャンセル</Button>
        <Button color="primary" onClick={onSubmit} disabled={productId == null || isSubmitting}>紐付ける</Button>
      </ModalFooter>
    </Modal>
  );
};
